import useAuth from '@hooks/auth.hook';
import Menu from '../../components/Menu';
import { NoAuthorized } from '@features/common';
import useMain from '../../hooks/main.hook';
import clsx from 'clsx';
import useMainContainerStyles from './MainContainer.styles';
import { MenuRoute } from '@interfaces/auth.interfaces';
import ContainerProps from '@interfaces/container.interface';

interface Props {
	Component: React.FC<ContainerProps>;
	id?: string;
}

const MainContainer: React.FC<Props> = ({ Component, id }) => {
	// Hooks
	const { getMenu, isLogged } = useAuth();
	const { menuState, toggleMenu } = useMain();
	const classes = useMainContainerStyles();

	// Variables
	const menuData: MenuRoute | undefined = id ? getMenu(id) : undefined;

	return (
		<>
			{isLogged() && <Menu menuState={menuState} toggleMenu={toggleMenu} />}
			<div
				className={clsx({
					[classes.contentBig]: menuState === 'big' && isLogged(),
					[classes.contentSmall]: menuState === 'small' && isLogged(),
				})}
			>
				{!menuData && id ? <NoAuthorized /> : <Component menuState={menuState} />}
			</div>
		</>
	);
};

export default MainContainer;
